import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AccountApiService } from '../../../services/account-api.service';
import { lastValueFrom } from 'rxjs';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FullPageMaskService } from 'common';

@Component({
  selector: 'si-token-generation-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, CommonModule, MatIconModule],
  templateUrl: './token-generation-dialog.component.html',
  styleUrl: './token-generation-dialog.component.scss',
})
export class TokenGenerationDialogComponent {
  public readonly dialogRef = inject(MatDialogRef<TokenGenerationDialogComponent>);
  public readonly accountApiService = inject(AccountApiService);
  public readonly clipboard = inject(Clipboard);
  public readonly snackBar = inject(MatSnackBar);
  public readonly maskService = inject(FullPageMaskService);

  public token: string;

  public handleClose() {
    this.dialogRef.close();
  }

  public async handleGenerateTokenButtonClick() {
    try {
      this.token = await lastValueFrom(this.accountApiService.getTokenGeneration());
      this.maskService.showLoading();
    } finally {
      this.maskService.hideLoading();
    }
  }

  public handleCopyButtonClick() {
    this.clipboard.copy(this.token);
    this.snackBar.open('Token copied', '', { duration: 1500 });
  }
}
